import { render, staticRenderFns } from "./TeamJoinForm.vue?vue&type=template&id=26e39fdd&"
import script from "./TeamJoinForm.vue?vue&type=script&lang=ts&"
export * from "./TeamJoinForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports